// extracted by mini-css-extract-plugin
module.exports = {"error":"src-components-ErrorInput-styles___error"};